<template>
  <header class="sklib-header">
    <div class="sklib-header__h1-wrapper">
      <h1 class="h1">国家社会科学基金项目分析平台</h1>
      <a class="logo" href="/"></a>
    </div>

    <nav class="sklib-header__nav">
      <router-link
        v-for="{ name, to, text } in routerLinkList"
        :key="name"
        :to="to"
        :class="formatNavLinkClassName(name)"
      >
        {{ text }}
      </router-link>
    </nav>
  </header>
</template>

<script>
export default {
  name: "SklibHeaderVue",
  data() {
    return {
      routerLinkList: [
        { to: { name: "PageHome" }, name: "PageHome", text: "首页" },
        {
          to: { name: "PageSubjectWordAnalysis" },
          name: "PageSubjectWordAnalysis",
          text: "主题词分析",
        },
        {
          to: { name: "PageSubjectTrendAnalysis" },
          name: "PageSubjectTrendAnalysis",
          text: "学科趋势分析",
        },
        {
          to: { name: "PageCollegesAndUniversitiesAnalysis" },
          name: "PageCollegesAndUniversitiesAnalysis",
          text: "院校分析",
        },
        // {
        //   to: { name: "PagePertinentLiterature" },
        //   name: "PagePertinentLiterature",
        //   text: "相关文献",
        // },
      ],
    };
  },
  methods: {
    formatNavLinkClassName(routerName) {
      const {
        $route: { name },
      } = this;
      return routerName === name ? "nav__link active" : "nav__link";
    },
  },
};
</script>

<style lang="scss" scoped>
.sklib-header {
  color: #ffffff;
  background: rgb(28, 95, 196);
  background: linear-gradient(
    180deg,
    rgba(28, 95, 196, 1) 0%,
    rgba(9, 155, 225, 1) 100%
  );

  .sklib-header__h1-wrapper {
    position: relative;
    margin: 0 auto;
    padding-top: 72px;
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 1400px;
    min-height: 80px;
    background: url("~@/assets/images/logo-new.png") top 8px left 8px / auto
      40px no-repeat;

    .h1 {
      font-size: 18px;
      font-weight: 800;
      text-align: center;
    }

    .logo {
      position: absolute;
      top: 0;
      left: 0;
      width: 180px;
      height: 60px;
    }
  }

  .sklib-header__nav {
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;

    .nav__link {
      &.active {
        border-bottom: 1px solid #ffffff;
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .sklib-header {
    background: linear-gradient(
      90deg,
      rgba(28, 95, 196, 1) 0%,
      rgba(9, 155, 225, 1) 100%
    );

    .sklib-header__h1-wrapper {
      padding: 0;
      background: url("~@/assets/images/logo-new.png") top 16px left 8px / auto
        48px no-repeat;

      .h1 {
        font-size: 26px;
        font-weight: 500;

        .break {
          display: none;
        }
      }

      .logo {
        width: 208px;
        height: 72px;
        cursor: pointer;
      }
    }

    .sklib-header__nav {
      padding-top: 0;
      justify-content: center;
      font-size: 20px;

      .nav__link {
        margin-right: 48px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}

@media screen and (min-width: 992px) {
  .sklib-header {
    .sklib-header__h1-wrapper {
      position: relative;
      background: none;

      &::before {
        content: "";
        position: absolute;
        bottom: -100%;
        left: 0;
        width: 320px;
        height: 64px;
        background: #000;
        background: url("~@/assets/images/logo-new.png") top 0 left 0 / auto
          64px no-repeat;
        transform: translateY(-100%);
      }

      .logo {
        top: 24px;
        width: 260px;
        height: 72px;
        cursor: pointer;
      }
    }
  }
}
</style>